// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner__banner___1qGjS","bannerParallax":"Banner__bannerParallax___SmFzd","bannerDramatic":"Banner__bannerDramatic___arI-N"};